import { Chakra } from "@airhelp/react-ui-components";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import bgStyles from "./Row.styles";
import type { RowProps } from "./Row.d";

const { Grid, Box } = Chakra;

const Row = ({
  pyMobile,
  mtMobile,
  mbMobile,
  pxMobile,
  pyTablet,
  mtTablet,
  mbTablet,
  pxTablet,
  pyDesktop,
  mtDesktop,
  mbDesktop,
  pxDesktop,
  bgStyle,
  id,
  display,
  content,
}: RowProps) => (
  <Box
    overflow="hidden"
    id={id}
    display={display}
    py={{ base: pyMobile, md: pyTablet, lg: pyDesktop }}
    mt={{ base: mtMobile, md: mtTablet, lg: mtDesktop }}
    mb={{ base: mbMobile, md: mbTablet, lg: mbDesktop }}
    px={{ base: pxMobile, md: pxTablet, lg: pxDesktop }}
    {...bgStyles[bgStyle as string]}
  >
    <Grid
      templateColumns={{ base: "repeat(4, 1fr)", md: "repeat(6, 1fr)", lg: "repeat(12, 1fr)" }}
      maxW="1202px"
      mx="auto"
      gap={4}
    >
      {content.map((item) => (
        <DynamicComponent blok={item} key={item._uid} />
      ))}
    </Grid>
  </Box>
);

export default Row;
